'use strict';
define([], function() {
    function Controller($scope, $mdDialog, projectId, location, KeywordTrackerService) {
        $scope.projectId = projectId;
        $scope.cancelDialog = cancelDialog;
        $scope.answerDialog = answerDialog;
        
        function answerDialog() {
            KeywordTrackerService.deleteLocation(projectId, location)
                .then(function() {
                    hideDialog();
                })
                .catch(function(err) {
                    console.log(err);
                });
        }
        function hideDialog() {
            $mdDialog.hide();
        }
        function cancelDialog() {
            $mdDialog.cancel();
        }
    }
    Controller.$inject=['$scope', '$mdDialog', 'projectId', 'location', 'KeywordTrackerService'];
    return Controller;
});